export default "__VITE_ASSET__DKin3VHa__"